import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-73906104")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, { class: "p-m-2" }, {
    header: _withId(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
        start: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('managers.cacheManagement.addRemoveDataset')), 1)
        ]),
        end: _withId(() => [
          _createVNode(_component_Button, {
            class: "kn-button p-button-text p-button-rounded",
            disabled: _ctx.cleanAllDisabled,
            onClick: _ctx.cleanAllConfirm,
            "data-test": "clean-all-button"
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('managers.cacheManagement.cleanAll')), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]),
        _: 1
      })
    ]),
    content: _withId(() => [
      _createVNode(_component_DataTable, {
        value: _ctx.datasets,
        loading: _ctx.loading,
        class: "p-datatable-sm kn-table",
        dataKey: "signature",
        responsiveLayout: "stack",
        breakpoint: "960px",
        "data-test": "dataset-table"
      }, {
        empty: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('managers.cacheManagement.metadataUnavailable')), 1)
        ]),
        loading: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.info.dataLoading')), 1)
        ]),
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.datasetTableCardDescriptor.columns, (col) => {
            return (_openBlock(), _createBlock(_component_Column, {
              field: col.field,
              header: _ctx.$t(col.header),
              key: col.field,
              style: col.style,
              class: "kn-truncated"
            }, null, 8, ["field", "header", "style"]))
          }), 128)),
          _createVNode(_component_Column, {
            style: _ctx.datasetTableCardDescriptor.table.iconColumn.style
          }, {
            body: _withId((slotProps) => [
              _createVNode(_component_Button, {
                icon: "pi pi-trash",
                class: "p-button-link",
                onClick: ($event: any) => (_ctx.deleteDatasetConfirm(slotProps.data.signature)),
                "data-test": "delete-button"
              }, null, 8, ["onClick"])
            ]),
            _: 1
          }, 8, ["style"])
        ]),
        _: 1
      }, 8, ["value", "loading"])
    ]),
    _: 1
  }))
})